import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
export function ProtocolIntro() {
  return <section className="py-12 md:py-24 bg-charcoal text-white" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-163">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/20 text-amber-400 mb-6 md:mb-8" data-id="element-164">
            <BookOpenIcon size={32} data-id="element-165" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8" data-id="element-166">
            Presentamos:{' '}
            <span className="text-amber-400" data-id="element-167">El Protocolo Cero Aullidos</span>
          </h2>

          <p className="text-lg md:text-2xl text-cream-200 leading-relaxed max-w-3xl mx-auto" data-id="element-168">
            Este no es un libro de entrenamiento tradicional. Es un sistema de
            reprogramación biológica basado en el Mecanismo de "Micro-Salidas
            Invisibles". Vamos a enseñarle al sistema nervioso de tu perro que
            tu partida es el evento más aburrido y seguro del día.
          </p>
        </motion.div>
      </div>
    </section>;
}